import lazyAssetsObserver from 'js/lib/lazy_assets';

require('./utils/lp_boclips_fetcher');
require('./utils/lp_boclips_video_handler');
require('./utils/lp_boclips_view_all_helper');
require('./actions/lp_boclips_actions');
require('./stores/video_media_tab_store');
require('./stores/video_mode_store');
require('./components/boclips_modal');
require('./components/lp_boclips_search_page');
require('./components/lp_boclips_videos_manager');
require('vendor/assets/components/jquery-file-download/src/Scripts/jquery.fileDownload');

const { $, LP } = window;
const Resources = LP.module('Resources');
const LpBoclips = LP.module('LpBoclips');
const { BoclipsModal } = LpBoclips;

const LpBoclipsHandler = {
  initShow() {
    if ($('body[data-controller*="boclips"]').length !== 1) {
      return;
    }
    if ($('body[data-action="show"]').length === 1) {
      this.show();
    }
  },

  show() {
    BoclipsModal.bindShowMore();
    BoclipsModal.bindScroll();
    BoclipsModal.bindExpandCompressPage();
    BoclipsModal.bindTooltips();
    BoclipsModal.bindTranscriptDownload();
    BoclipsModal.bindCopyLinkButton();
    Resources.show();
    if (LP.config.logged_in) {
      const videoUrl = $('#bo_player_modal').data('video-url');
      const videoHandler = new LpBoclips.LpBoclipsVideoHandler({
        videoUrl,
        data: { ...($('#bo_player_modal').data() || {}), from_rrp: true }
      });
      const playerContainer = $('#bo_player_modal').find('#boclips-player');
      if (playerContainer.length > 0) {
        videoHandler.init(playerContainer[0]);
      }
    }
  }
};

LpBoclips.site = function () {
  if ($('#boclips-videos-section').length === 1) {
    BoclipsModal.bindCopyLinkButton();
    return true; // handled by LpBoclipsSearchPage react component
  }
  return LpBoclipsHandler.initShow();
};
